import { ORDER_METHODS } from '~constants/address';

export const isMethodConsistent = (orderMethod, dispatchMethod) =>
  orderMethod === ORDER_METHODS.BOTH || orderMethod === dispatchMethod;
